import { Resource } from '@redge-media/fo-js-sdk';
import Section from './section';

const Sections = Resource.extend({
  endpoint: '/products/sections',

  constructor: function Sections(opts = {}) {
    Resource.call(this);

    this.id = opts.id;
    this.label = (opts.id != null) ? null : opts.label || 'main';
    this.category = opts.category;
    this.recordClass = Section;
  },

  getPath(method, props = {}) {
    let path = Resource.prototype.getPath.call(this, method, props);
    if (method === 'fetchAll') {
      path += (this.id != null) ? `/${this.id}` : `/${this.label}`;
    }

    if (this.category) {
      path += `_catalog?categoryId=${this.category.id}`;
    }

    return path;
  },
});

export default Sections;
